import React, { useState, useEffect } from "react";
import { Input, Checkbox, Spin } from "antd";
import { SearchOutlined, LoadingOutlined } from "@ant-design/icons";
import Swal from "sweetalert2";
import GetImage from "../../../components/getimage/Getimage";
import TooltipButton from "../../../components/tooltip/Popover";
import Hexapi from "../../../utility/HexAPI/Hexapi";

export default function Step3({
	defaultattendee,
	formData,
	setFormData,
	attendessarr,
	userid,
	curmeetingid,
}) {
console.log(formData,"formData")
	const [employees, setEmployees] = useState([]);
	const [filtered, setFiltered] = useState([]);
	const [selectedMap, setSelectedMap] = useState({});
	const [search, setSearch] = useState("");
	const [conflictData, setconflictData] = useState(null);
	const [checkingId, setCheckingId] = useState(null);

	const SELECT_ALL_ID = "__selectAll__";

	const checkAttendeeOverlap = async (attendeesStr) => {
		try {
			const scheduledTime = formData?.meetingTime?.format
				? formData.meetingTime.format("YYYY-MM-DD HH:mm:ss")
				: formData?.meetingTime;

			const curMeetingId =
				curmeetingid !== undefined && curmeetingid !== null
					? curmeetingid
					: -1;

			const res = await Hexapi({
				query:
					"HRApp_Droid_Proc_AddMeeting_AttendeesOLC @UserID='{0}', @ScheduledTime='{1}', @Attendees='{2}', @CurMeetingID='{3}',@Duration='{4}'",
				queryArr: [
					userid,
					scheduledTime,
					attendeesStr,
					curMeetingId,
formData.durationnumber
				],
			});

			console.log(res, "Overlap check response");
			const conflict = res?.olc?.[0];

			if (conflict && conflict.msg) {
				setconflictData(res?.olc?.[0].msg);
			} else {
				setconflictData(null);
			}

			return true;
		} catch (err) {
			console.error("Overlap check failed:", err);
			Swal.fire({
				icon: "error",
				title: "Could not verify availability",
				text: "Please try again.",
			});
			return false;
		}
	};

	useEffect(() => {
		if (!attendessarr) return;

		const normalized = attendessarr.map((emp) => ({
			value: emp?.empid,
			label: `${emp?.firstname} ${emp?.lastname}`,
		}));

		setEmployees(normalized);
		setFiltered(normalized);

		let selectedIds = [];

		if (formData.attendees) {
			selectedIds = formData.attendees.split(",");
		} else {
			if (!defaultattendee) selectedIds = [String(userid)];
			else selectedIds = [String(userid), String(defaultattendee)];
		}

		const map = {};
		selectedIds.forEach((id) => (map[id] = true));

		setSelectedMap(map);

		const initialAttendeesStr = selectedIds.join(",");

		setFormData((prev) => ({
			...prev,
			attendees: initialAttendeesStr,
		}));

		// FIX: on mount / whenever the attendee list (re)loads, run the
		// overlap check once for the default/pre-selected attendees too —
		// previously the check only ran when the user manually ticked
		// someone, so the initial/default attendees were never validated
		// for conflicts until something else was toggled.
		if (initialAttendeesStr) {
			(async () => {
				setCheckingId("__initial__");
				await checkAttendeeOverlap(initialAttendeesStr);
				setCheckingId(null);
			})();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [attendessarr, userid]);

	const storeSearch = (e) => {
		const value = e.target.value;
		setSearch(value);

		if (!value) {
			setFiltered(employees);
		} else {
			const f = employees.filter((emp) =>
				emp.label.toLowerCase().includes(value.toLowerCase()),
			);
			setFiltered(f);
		}
	};

	// FIX: overlap check now runs on BOTH select and unselect — previously
	// unticking someone skipped the check entirely and just removed them.
	const toggleEmployee = async (emp) => {
		if (checkingId) return;

		const alreadySelected = !!selectedMap[emp.value];

		const currentArr = formData?.attendees
			? formData.attendees.split(",").filter(Boolean)
			: [];

		const newArr = alreadySelected
			? currentArr.filter((id) => id !== String(emp.value))
			: currentArr.includes(String(emp.value))
				? currentArr
				: [...currentArr, String(emp.value)];

		const newAttendeesStr = newArr.join(",");

		setCheckingId(emp.value);
		await checkAttendeeOverlap(newAttendeesStr);
		setCheckingId(null);

		setSelectedMap((prev) => ({ ...prev, [emp.value]: !alreadySelected }));
		setFormData((prev) => ({ ...prev, attendees: newAttendeesStr }));
	};

	// FIX: Select All / clear-all now also runs the overlap check against
	// the full resulting attendee list before applying the selection.
	const selectAll = async (e) => {
		if (checkingId) return;

		const checked = e.target.checked;

		if (checked) {
			const ids = filtered.map((emp) => String(emp.value));
			const currentArr = formData?.attendees
				? formData.attendees.split(",").filter(Boolean)
				: [];
			const mergedArr = [...ids, ...currentArr.filter((id) => !ids.includes(id))];
			const newAttendeesStr = mergedArr.join(",");

			setCheckingId(SELECT_ALL_ID);
			await checkAttendeeOverlap(newAttendeesStr);
			setCheckingId(null);

			const map = {};
			ids.forEach((id) => (map[id] = true));
			setSelectedMap((prev) => ({ ...prev, ...map }));

			setFormData((prev) => ({
				...prev,
				attendees: newAttendeesStr,
			}));
		} else {
			setCheckingId(SELECT_ALL_ID);
			await checkAttendeeOverlap("");
			setCheckingId(null);

			setSelectedMap({});
			setFormData((prev) => ({
				...prev,
				attendees: "",
			}));
		}
	};

	const attendeeOrder = formData?.attendees
		? formData.attendees.split(",")
		: [];

	const sortedFiltered = [
		...attendeeOrder
			.map((id) => filtered.find((emp) => String(emp.value) === id))
			.filter(Boolean),

		...filtered.filter((emp) => !selectedMap[emp.value]),
	];

	const empIds = attendeeOrder;

	const circle = (color, ml = 0, z = 1) => ({
		width: "34px",
		height: "34px",
		borderRadius: "50%",
		backgroundColor: color,
		border: "2px solid white",
		marginLeft: ml,
		zIndex: z,
		overflow: "hidden",
	});

	const listLocked = !!checkingId;
	const selectAllChecking = checkingId === SELECT_ALL_ID;

	return (
		<div className="container-fluid" style={{ overflow: "hidden" }}>
			<div className="row">
				<p className="selectmeetingtime">
					Select Meeting Attendees{" "}
					<TooltipButton fieldName={"MeetingAttendees"} />
				</p>

				<div className="col-12">
					{/* HEADER */}
					<div className="row mb-2">
						<div className="col-4">
							<Input
								placeholder="Search"
								allowClear
								value={search}
								onChange={storeSearch}
								prefix={<SearchOutlined />}
							/>
						</div>

						<div className="col-2 d-flex justify-content-center align-items-center">
							{selectAllChecking ? (
								<Spin
									indicator={<LoadingOutlined style={{ fontSize: 14 }} spin />}
								/>
							) : (
								<Checkbox
									onChange={selectAll}
									disabled={listLocked}
									checked={
										filtered.length > 0 &&
										filtered.every((emp) => selectedMap[emp.value])
									}
								>
									Select All
								</Checkbox>
							)}
						</div>

						<div className="col-4 d-flex justify-content-center">
							<div style={{ display: "flex", alignItems: "center" }}>
								{empIds[0] && (
									<div style={circle("#60a5fa")}>
										<GetImage imgID={empIds[0]} width="100%" height="100%" />
									</div>
								)}

								{empIds[1] && (
									<div style={circle("#f87171", "-11px", 2)}>
										<GetImage imgID={empIds[1]} width="100%" height="100%" />
									</div>
								)}

								{empIds.length > 2 && (
									<div
										style={{
											...circle("#9ca3af", "-11px", 3),
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
											fontSize: "10px",
											color: "#fff",
										}}
									>
										+{empIds.length - 2}
									</div>
								)}
							</div>
						</div>
					</div>

					{/* LIST + RIGHT SPACE */}
					<div className="row">
						<div className="col-9">
							<div
								style={{
									maxHeight: "300px",
									overflowY: "auto",
									overflowX: "hidden",
									paddingBottom: "15vh",
								}}
							>
								<div className="row">
									{sortedFiltered.map((emp) => {
										const isChecked = !!selectedMap[emp.value];
										const isChecking = checkingId === emp.value;
										const isDisabled = listLocked;

										return (
											<div className="col-4 mb-2" key={emp.value}>
												<div
													className="d-flex align-items-center p-2"
													style={{
														cursor: isDisabled ? "not-allowed" : "pointer",
														border: "1px solid #eee",
														borderRadius: "6px",
														background: isChecked ? "#f0f8ff" : "",
														opacity: isDisabled ? 0.6 : 1,
													}}
													onClick={() => !isDisabled && toggleEmployee(emp)}
												>
													{isChecking ? (
														<Spin
															indicator={
																<LoadingOutlined
																	style={{ fontSize: 14 }}
																	spin
																/>
															}
															style={{ marginRight: 6 }}
														/>
													) : (
														<Checkbox
															checked={isChecked}
															disabled={isDisabled}
															style={{ marginRight: 6 }}
														/>
													)}

													<GetImage
														imgID={emp.value}
														width="30px"
														height="30px"
														redirect={false}
													/>

													<span
														style={{
															fontSize: "clamp(12px, 1vw, 14px)",
															marginLeft: "6px",
														}}
													>
														{emp.label}
													</span>
												</div>
											</div>
										);
									})}
								</div>
							</div>
						</div>

						<div className="col-3" style={{ paddingLeft: "0px" }}>
							
							{conflictData && (
								<div
	style={{
		height: "300px",
		maxWidth: "100%",
		overflowY: "auto",
		overflowX: "hidden",
		scrollbarWidth: "none",
		msOverflowStyle: "none",
paddingBottom: "20vh",
	}}
>
									<div
										style={{
											width: "100%",
											wordBreak: "break-word",
											overflowWrap: "break-word",
											whiteSpace: "normal",

										}}
										dangerouslySetInnerHTML={{ __html: conflictData }}
									></div>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
